import React from 'react';
import { useTranslate } from '../../contexts/languageContext';
import EstadisticasConsolidadoTabla_Cabecera from './EstadisticasConsolidadoTabla_Cabecera';
import EstadisticasConsolidadoTabla_FilaCampo from './EstadisticasConsolidadoTabla_FilaCampo';
import styled from 'styled-components/macro';

const EstadisticasConsolidadoTabla = (props) => {
  const t = useTranslate();
  return (
    <TablaEstadisticas >
      <EstadisticasConsolidadoTabla_Cabecera data={props.data}/>
      <EstadisticasConsolidadoTabla_FilaCampo title={props.data.nombre} data={props.data.data[0]}/>
    </TablaEstadisticas>
  );
};

const TablaEstadisticas = styled.section`
  width:95%;
  background-color: white;
`;

export default EstadisticasConsolidadoTabla;